import React, { useMemo } from "react";
import InputMascara from "./InputMascara";
import useFormItemStatus from "antd/es/form/hooks/useFormItemStatus";

// Função para validar CPF
export const validarCPF = (cpf) => {
	// Remove caracteres não numéricos
	cpf = cpf.replace(/\D/g, "");

	// Verifica se tem 11 dígitos
	if (cpf.length !== 11) return false;

	// Verifica se todos os dígitos são iguais (ex: 111.111.111-11)
	if (/^(\d)\1+$/.test(cpf)) return false;

	// Validação dos dígitos verificadores
	let soma = 0;
	let resto;

	// Primeiro dígito verificador
	for (let i = 1; i <= 9; i++) {
		soma += parseInt(cpf.substring(i - 1, i)) * (11 - i);
	}

	resto = (soma * 10) % 11;
	if (resto === 10 || resto === 11) resto = 0;
	if (resto !== parseInt(cpf.substring(9, 10))) return false;

	// Segundo dígito verificador
	soma = 0;
	for (let i = 1; i <= 10; i++) {
		soma += parseInt(cpf.substring(i - 1, i)) * (12 - i);
	}

	resto = (soma * 10) % 11;
	if (resto === 10 || resto === 11) resto = 0;
	if (resto !== parseInt(cpf.substring(10, 11))) return false;

	return true;
};

// Validador de CPF para uso em rules do Form.Item
export const cpfValidator = (_, value) => {
	if (!value) return Promise.reject(new Error("CPF é obrigatório"));

	// Se o CPF não tem 11 dígitos após remover a formatação, consideramos incompleto
	const cpfSemFormatacao = value.replace(/\D/g, "");
	if (cpfSemFormatacao.length < 11)
		return Promise.reject(new Error("CPF incompleto"));

	// Valida o CPF
	if (!validarCPF(value)) {
		return Promise.reject(new Error("CPF inválido"));
	}

	return Promise.resolve();
};

export default function InputCpf(props) {
	const { value, onChange } = props;
	const formStatus = useFormItemStatus();

	const classes = useMemo(() => {
		const classes = [];
		if (formStatus.status === "error") {
			classes.push("ant-input-status-error");
		}
		return classes;
	}, [formStatus]);

	return (
		<InputMascara
			mask={{
				11: "999.999.999-99",
			}}
			value={value}
			onChange={onChange}
			classes={classes}
		/>
	);
}
